{
    "button__in_1_week": "In 1 Week",
    "button__in_4_week": "In 4 Weeks"
}
